import { render, staticRenderFns } from "./StudentsIndex.vue?vue&type=template&id=3a3d1f4a&scoped=true&"
import script from "./StudentsIndex.vue?vue&type=script&lang=js&"
export * from "./StudentsIndex.vue?vue&type=script&lang=js&"
import style0 from "./StudentsIndex.vue?vue&type=style&index=0&id=3a3d1f4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3d1f4a",
  null
  
)

export default component.exports